import axiosClient from "@/shared/lib/axios/axios.ts";
import { AxiosResponse } from "axios";
import { ApiResponse } from "@/shared/types/api.ts";
import { API_ROUTES } from "@/export/api/config.ts";

export interface IExportInput {
  device_mxids: string; // Comma-separated list of device_mxid strings
  start_time: string; // Start of time range (inclusive), YYYY-MM-DD HH:MM:SS UTC
  end_time: string; // End of time range (inclusive), YYYY-MM-DD HH:MM:SS UTC
  timezone?: string; // IANA timezone for output datetimes (default UTC)
}

export interface IExportResponse {
  url: string; // Signed URL valid for 1 hour
}

// GET /api/export/ - Export Events, Truck Cycles & Alerts to Excel
export const exportData = async (params: IExportInput): Promise<ApiResponse<IExportResponse>> => {
  const queryParams = new URLSearchParams({
    device_mxids: params.device_mxids,
    start_time: params.start_time,
    end_time: params.end_time,
    ...(params.timezone && { timezone: params.timezone }),
  });

  return axiosClient
    .get<any, AxiosResponse<ApiResponse<IExportResponse>>>(
      `${API_ROUTES.EXPORT}?${queryParams.toString()}`
    )
    .then((res) => res.data);
};